import axios from "axios";

export const mailvibesApi = axios.create({
  baseURL: process.env.REACT_APP_API,
  timeout: 30000,
});
